/**
 * 转换时间 hh:mm:ss
 * @param {timestramp} date 
 * @returns { string } string
 */
 export function toHHmmss (date) {
  var time;
  var hours = parseInt((date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = (date % (1000 * 60)) / 1000;
  time = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
  return time;
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/time.js